module.exports = {
    api_domain: {
        domain: process.env.API_URL || "https://auteco-blue-1076238613143.us-east1.run.app"
        // domain: process.env.API_URL || "https://auteco-blue-test-s3c265wysa-ue.a.run.app" 
        // domain: process.env.API_URL || "http://localhost:3001"
    }
}